import * as v from "valibot";

import { authResultSchema } from "./auth";

import { rpcContract } from "../rpc";

export const authSessionRpcContract = rpcContract({
  paramsSchema: v.object({}),
  resultSchema: authResultSchema,
  name: "auth-session",
});
